import { render, staticRenderFns } from "./wait_workorder.vue?vue&type=template&id=d81128de"
import script from "./wait_workorder.vue?vue&type=script&lang=js"
export * from "./wait_workorder.vue?vue&type=script&lang=js"
import style0 from "./wait_workorder.vue?vue&type=style&index=0&id=d81128de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports